import { Box } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { ProductShelvingRequirementFormValues } from "../../types"

import { FormBooleanRadioGroup, FormSelect } from "@/components/UiKit"
import { BIN_SIZE_OPTIONS } from "@/constants/warehouse"

const ProductShelvingRequirementForm: FC = () => {
  const { control, watch, setValue } = useFormContext<ProductShelvingRequirementFormValues>()
  const coldStorage = Boolean(watch("coldStorage"))

  const handleColdStorageChange = () => setValue("h3ColdStorage", false)

  return (
    <Box className='flex flex-col gap-6'>
      <FormBooleanRadioGroup
        control={control}
        name='coldStorage'
        label='Cold Storage'
        required
        data-testid='cold-storage-radio-group'
        onChange={handleColdStorageChange}
      />
      <FormBooleanRadioGroup
        control={control}
        name='h3ColdStorage'
        label='H3 Storage'
        required={coldStorage}
        disabled={!coldStorage}
        data-testid='h3-storage-radio-group'
      />
      <FormSelect
        control={control}
        name='binSize'
        label='Bin Size'
        required
        placeholder='Please Select'
        options={BIN_SIZE_OPTIONS}
        data-testid='bin-size-select'
      />
      <FormBooleanRadioGroup control={control} name='deep' label='Deep' required data-testid='deep-radio-group' />
      <FormBooleanRadioGroup
        control={control}
        name='stackable'
        label='Stackable'
        required
        data-testid='stackable-radio-group'
      />
    </Box>
  )
}

export default ProductShelvingRequirementForm
